import functions from './functions.js';
import Slider from './Slider.js';
import {SimpleGuests, SimpleGuestsDefaults} from "./simple-guests.js";
import {FormGuide, FormGuideDefaults} from "./form-guide.js";
import lozad from 'lozad';

//SimpleGuestsDefaults.maxInfants = 0;
SimpleGuestsDefaults.adultsLabel = 'Adults +18 years';
SimpleGuestsDefaults.childrenLabel = 'Children 12-$y years';
SimpleGuestsDefaults.infantsLabel = 'Children up to $y years';

$(function() {

    if (functions.isMobile()) 
    {
        $('.show-on-desktop').remove();
        $('.show-on-mobile').removeClass('d-none');
    }
    else 
    {
        $('.show-on-mobile').remove();
        $('.show-on-desktop').removeClass('d-none');
    }

    $('body').on('click', '.dropdown-menu', e => {
        e.stopPropagation();
    });

    $('.simple-guests').each((i, elem) => {
		elem._simpleGuests = new SimpleGuests(elem);
	});

    $('.form-guide').each((i, elem) => {
		new FormGuide(elem);
	});


    if($('.gatracking').length)
    {
        let trackingData = JSON.parse($('[data-gatracking]').attr('data-gatracking'));
        if (trackingData)
        {
            functions.pushTrackingData(trackingData);
        }
    }

    let catalogueSliderCrads = [];
    $('[id^=catalogue-slider-cards]').each((i, elem) => {
        catalogueSliderCrads[i] = new Slider('#' + $(elem).attr('id'), {
            rubberband: false,
            loop: false,
            arrows: false,
            slides: {
                perView: 3,
                spacing: 5,
            },
            pager: false,
            constrols: true,
            autoplay: 0,
            drag: true,
            pauseOnHover: false,
            breakpoints: {
                '(max-width: 1000px)': {

                    origin: 'center',
                    slides: {
                        perView: 2.15,
                        spacing: 0,
                    },

                    loop: false,
                    controls: true,
                    drag: true,
                    arrows: false,
                    autoplay: 0
                },
                '(max-width: 768px)': {

                    origin: 'center',
                    slides: {
                        perView: 1.07,
                        spacing: 10,
                    },

                    loop: false,
                    controls: true,
                    drag: true,
                    arrows: false,
                    autoplay: 0
                },
            },
            selector: '.first-slide',
        });
    });

    $('[id^=card-slider]').each((i, elem) =>
        {
            let $items = $(elem).find('.keen-slider__slide.card-slide');
            new Slider('#' + $(elem).attr('id'), {
                //items: $items,
                selector: '.keen-slider__slide.card-slide',
                loop: true,
                drag: $items.length > 3 ? true : false,
                arrows: true,
                pager: true,
                slides: {
                    perView: 3,
                    spacing: 0
                },
                breakpoints: {
                    '(max-width: 1000px)': {
    
                        origin: 'center',
                        slides: {
                            perView: 2.15,
                            spacing: 0,
                        },
    
                        loop: false,
                        controls: true,
                        drag: true,
                        arrows: false,
                        autoplay: 0
                    },
                    '(max-width: 768px)': {
    
                        origin: 'center',
                        slides: {
                            perView: 1.07,
                            spacing: 10,
                        },
    
                        loop: false,
                        controls: true,
                        drag: true,
                        arrows: false,
                        autoplay: 0
                    },
                },
            });
        });

   const observerVillas = lozad('.villas-lozad', {
    rootMargin: '200px 200px',
    loaded: el => {
        let ss = [];
        $(el).find('[id^=villa-card-slider]').each((i, elem) => {
            const $items = $(elem).find('.keen-slider__slide');
            ss[i] = new Slider('#' + $(elem).attr('id'), {
                rubberband: false,
                items: $items,
                drag: false,
                loop: true,
                arrows: true,
                spacing: 0,
                pager: false,
                slides: {
                    perView: 1,
                    spacing: 0
                },
                autoLoadSlides: 2
            });
        });
            $(el).triggerHandler('lozadLoaded');
    }
});
observerVillas.observe();
        
        
        


        let blogSlider = [];
        $('[id^=blog-slider]').each((i, elem) => {
            const length = $(elem).children('.keen-slider__slide').length;
        blogSlider[i] = new Slider('#' + $(elem).attr('id'), {
            rubberband: true,
            loop: true,
            arrows: true,
            drag: true,
            controls: true,
            slides: {
                origin: "auto",
                perView: 3,
                spacing: 30,
            },
            autoLoadSlides: 6,
            duration: 1000,
            autoplay: 0,
            pauseOnHover: true,
            pager: true, 
            breakpoints: {
                '(max-width: 1000px)': {

                    slides: {
                        origin: 'auto',
                        perView: 1.1,
                        spacing: 20,
                    },
                    loop: true,
                    controls: true,
                    drag: true,
                    arrows: true,
                    autoplay: 0
                },
            },      
        });
    });

    /* gallery */
    const lg = {};
    window.showGallery = (index, id) => {
        index = +index || 0;
        if ( lg[id] ) {
            lg[id].index = index;
            lg[id].build(index);
        } else {
            let $elem = $('[data-images-' + id + ']');
            lg[id] = $elem.lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                preload: 2,
                index: index,
                dynamicEl: JSON.parse($elem.attr('data-images-' + id))
            }).data('lightGallery');
        }
    };
    $('[data-gallery-id]').on('click', function (e) {
        e.preventDefault();
        let galleryId = $(this).attr('data-gallery-id');
        galleryId && showGallery($(this).attr('data-index'), galleryId);
    });
    // don't focus div with gallery
    $('[data-gallery-id]').on('focus', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
    });
    /* end gallery */
    
    // menu links active
    const path = location.pathname.replace(/\/$/, '');
    $('.main-header [href], footer [href]').each((i, link) => {
        let href = link.getAttribute('href');
        if ( href && href != '#' ) {
            href = href.split('?')[0].replace(/\/$/, '');
            if ( path === href ) {
                $(link).addClass('active').closest('.nav-item').addClass('active');
            }
        }
    });



    

    

    // global tooltip init
    //('[data-toggle="tooltip"]').tooltip();

    // mobile menu handling
    (() => {
        const $header = $('.main-header');
        const $collapser = $('#main-menu');

        // ensure navbar toggler also open closes main-menu
        $collapser
            .on('show.bs.collapse', () => {
                document.body.classList.add('modal-transition');
                document.body.classList.add('modal-active');
            })
            .on('hide.bs.collapse', () => {
                document.body.classList.remove('modal-active');
            })
            .on('hidden.bs.collapse', () => {
                document.body.classList.remove('modal-transition');
            });

        // click on "overlay" closes menu
        $header.find('.header-overlay').on('click', () => {
            $collapser.collapse('hide');
        });
    })();

    // scrool to element handling
    $(document).on('click', '[data-scroll-to]', e => {
        e.preventDefault();
        const $this = $(e.target);
        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });
    
    // global datepicker init with automatic "dateTo" set if provided
    let displayDate = new Date('2019-06-01');
    let now = functions.cleanDate(new Date);
    if ( now > displayDate ) {
        displayDate = now;
    }

    $('.datepicker').each((i, elem) => {
        const $datepicker = $(elem);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        $datepicker.flatpickr({
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            minDate: minDate ? minDate : now,
            maxDate: maxDate ? maxDate : null,
            disableMobile: true,
            prevArrow: '<i class="la la-angle-left pr-2"></i>',
            nextArrow: '<i class="la la-angle-right pl-2"></i>',
            onChange(selectedDates, dateStr, instance) {

                const $first = $(instance.input);
                // prevent other logic if second datepicker is triggered by first
                if (instance._openByFirst) {
                    delete instance._openByFirst;
                    return;
                }
                
                if ($first.attr('data-firstDate')) {
                    const $second = $first.closest('form').find('[data-secondDate]').closest('.datepicker');
                    if ($second.length) {

                        var firstDate = new Date(selectedDates[0]);
                        firstDate.setDate(firstDate.getDate() + 1);
                        
                        var secondInstance = $second[0]._flatpickr;
                        // check if firstDate is invalid
                        if (firstDate.getTime() === firstDate.getTime()) {
                            secondInstance._openByFirst = true;
                            secondInstance.set('minDate', firstDate);
                            if (!secondInstance.selectedDates[0]) {
                                firstDate.setDate(firstDate.getDate() + 6);
                                secondInstance.setDate(firstDate);
                            }
                            secondInstance.open();
                            $(secondInstance.altInput).focus();
                        }
                        else if (secondInstance.selectedDates[0]) {
                            secondInstance.clear();
                        }
                    }
                }
                // check if second date is cleared
                else if ($first.attr('data-secondDate') && !selectedDates[0]) {
                    $first.closest('form').find('[data-firstDate]').closest('.datepicker')[0]._flatpickr.clear();
                }
            },
            onOpen(selectedDates, dateStr, instance) {
                if (instance.input.getAttribute('data-secondDate')) {
                    const $first = $(instance.input).closest('form').find('[data-firstDate]').closest('.datepicker');
                    if ($first.length) {
                        const firstInstance = $first[0]._flatpickr;
                        if (!firstInstance.input.value) {
                            instance.close();
                            firstInstance.open();
                            firstInstance.altInput.focus();
                            return;
                        }
                    }
                }
                !dateStr && instance.jumpToDate(minDate ? minDate : displayDate);
            }
        });
        // to style clear toggler
        $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    }); 

    $('.datepicker-range').each((i, elem) => {
        const $datepicker = $(elem);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        const arrival = $datepicker.attr('data-arrival') ? $datepicker.attr('data-arrival') : [];
        const defaultDate = $datepicker.attr('data-defaultDate') ? $datepicker.attr('data-defaultDate') : [];
        const duration = Number($datepicker.attr('data-duration'));
        const position = $datepicker.attr('data-position') || 'auto';
        const minStayText = $datepicker.attr('data-minstay');
        $datepicker.flatpickr({
            mode: "range",
            showMonths: functions.isMobile() ? 1: 2,
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            defaultDate: defaultDate,
            minDate: minDate && minDate >= now ? minDate : now,
            maxDate: maxDate ? maxDate : null,
            disableMobile: true,
            prevArrow: '<i class="la la-arrow-left la-fw la-2x pr-2"></i>',
            nextArrow: '<i class="la la-arrow-right la-fw la-2x pl-2"></i>',
            locale: {
                rangeSeparator: ' - '
            },
            position: position,
            minStayText: minStayText ? minStayText : '',
            onDayCreate(dObj, dStr, fp, dayElem){
                
                let minStay = 3;
                let to = new Date(maxDate);
                let weekday =  new Date(dayElem.dateObj).getDay();
                weekday = '' + (weekday ? weekday : 7);
                to.setHours(0, 0, 0, 0);
                let onlyCheckInSelected = fp.selectedDates[0] && ! fp.selectedDates[1];
                // let diff = globals.dateDiff(dayElem.dateObj, fp.selectedDates[0]);
                let from = dayElem.dateObj;
                let too = fp.selectedDates[0];
                // let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
                // let t = Date.UTC(too.getFullYear(), too.getMonth()+1, too.getDate());
            
                let diff = Math.round((from - too) / (1000 * 60 * 60 * 24));

                if (onlyCheckInSelected) {
                    if (Math.abs(diff) < minStay) {
                        dayElem.className += ' flatpickr-disabled ';
                        if (diff) {
                            $(dayElem).tooltip({
                                title: minStayText.replace('{$min_stay}', minStay) || ''
                            });
                        }
                    }
                }

                if ( dayElem.dateObj > to || (arrival.length && $.inArray( weekday , arrival ) == -1) ) {
                    dayElem.classList.add('unselectable');
                }
            },
        });
        // to style clear toggler
        $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    });

    let userDates = functions.getCookie('user_dates');
    if(userDates) {
        let userDateFrom = new Date(userDates.split(' - ')[0]);
        let today = new Date( new Date().getFullYear(), new Date().getMonth(), new Date().getDate() );
    
        if(userDateFrom < today) {
            functions.setCookie('user_dates', '');
            userDates = functions.getCookie('user_dates');
        }
    }

    let cookieConsent = functions.getCookie('cookie_consent');
    if (! cookieConsent)
    {
        if ($('.map-and-filters').length) $('.map-and-filters').addClass('pb-60px');
        if ($('.list').length) $('.list').addClass('pb-80px');
        let $cookieBar = $('#cookie-bar');
        $cookieBar.removeClass('d-none');

        $cookieBar.find('.cookie-agree').on('click', (e) => {
            $cookieBar.addClass('d-none');
            functions.setCookie('cookie_consent', (Math.random() * 10000).toString(36));
            if ($('.map-and-filters').length) $('.map-and-filters').removeClass('pb-60px');
            if ($('.list').length) $('.list').removeClass('pb-80px');
           
        })
    }


    if(userDates && $('.datepicker-range')[0]) {
        userDates = userDates.split(' - ');
        if(userDates.length == 2) $('.dates-clear').removeClass('d-none');
        let dateFrom = userDates[0] ? userDates[0] : null;
        let dateTo = userDates[1] ? userDates[1] : null;
    
        if(dateFrom && dateTo) {
            $('.datepicker-range')[0]._flatpickr.setDate([dateFrom, dateTo]);
        } else if(dateFrom) {
            $('.datepicker-range')[0]._flatpickr.setDate([dateFrom, dateFrom]);
        }
    }

    $('[name="dates"]').on('change', e => {
        functions.setCookie('user_dates', $(e.target).val());
    });

    // select2 templates can be defined as data-template="destinations" ...
    const selectTemplates = {
        destinations: data => {
            if ( !data.element ) {
                return data.text;
            }
            if(data.placeId && data.placeName) {
                //const $element = $(data.element).addClass(data.element.className).text(data.placeName);
                const $element = $('<span>').addClass(data.element.className).text(data.placeName);
                return $element;
            }
            if(data.text) {
                const $element = $('<span>').addClass(data.element.className).text(data.text);
                let elemClass;
                switch ( (data.dest).split(':').length ) {
                    case 1: elemClass = 'ps-1 fw-bold'; break;
                    case 2: elemClass = 'ps-3 fw-bold'; break;
                    case 3: elemClass = 'ps-5 '; break;
                    case 4: elemClass = 'ps-5 '; break;
                    default: elemClass = 'h5'; break;
                }
                $element.addClass(elemClass);
                return $element;
            }
        },
    };

    // global init select2
    // data-templates
    // data-data
    // data-allow-clear
    // data-nosearch
    // placeholder
    $.map($('.select2'), elem => {
        const $elem = $(elem);
        const config = { dropdownParent: $elem.parent(), language: functions.getLang() };
        config.allowClear = $elem.attr('data-allow-clear');

        // find select2 which has an attribute data-data
        const data = $elem.attr('data-data');
        if ( data ) {
            try {
                config.data = JSON.parse(data);
            } catch (e) {}
        } 
        else if ( $elem.attr('data-special') ) {
            let newData = $('body').attr('data-select-' + $elem.attr('data-special'));
            config.data = JSON.parse(newData);
        }

        if ( $elem.attr('data-template') ) {
            config.templateResult = selectTemplates[$elem.attr('data-template')];
        }
        if ( $elem.attr('data-template-selection') ) {
            config.templateSelection = selectTemplates[$elem.attr('data-template-selection')];
        }

        if ( $elem.attr('data-nosearch') !== undefined ) {
            config.minimumResultsForSearch = Infinity;
        }

        let placeholder = $elem.attr('placeholder');
        $elem.removeAttr('placeholder');
        config.placeholder = placeholder || ' ';
        
        $elem.select2(config)
            .on('select2:clear', () => {
                $elem[0].cleared = true;
            })
            .on('select2:opening', e => {
                if ( $elem[0].cleared ) {
                    e.preventDefault();
                    $elem[0].cleared = false;
                }
            });
    });
    
    // advanced form controls
    // input-popover
    $('body').on('click', '.dropdown-menu-popover', e => {
        e.stopPropagation();
    });

    $('#cookie-bar-accept').on('click', function (e) {
        functions.setCookie('cookie_usage', 'accepted');
        $("#cookie-bar").addClass('d-none');
    });

    // $('.currency').on('click', function (e) {
    //     functions.setCookie('currency', $(this).data('currency'));
    //     location.reload();
    // });

    $('.currency-change').on('click', function (e) {
        functions.setCookie('currencyIdTo', e.target.id);
        location.href = location.origin + location.pathname;
    });



    function showFixedExchangeRate()
    {
        let language = functions.getLang();
        let date = new Date();
        const x = new Date('2022-12-31');
        const y = new Date('2023-07-01');

        let currencyId = functions.getCookie('currencyIdTo') || 1;
        let text = {
                'hr' : 'Fiksni tečaj konverzije: 1 € = 7,53450 kn',
                'en' : 'Fixed conversion rate: 1 € = 7,53450 kn',
                'de' : 'Feste Conversion-Rate: 1 € = 7,53450 kn',
                'it' : 'Tasso di conversione fisso: 1 € = 7,53450 kn',
                'fr' : 'Taux de conversion fixe : 1 € = 7,53450 HRK',
                'pl' : 'Stały kurs wymiany: 1 € = 7.53450 HRK',
                'hu' : 'Rögzített átváltási árfolyam: 1 € = 7,53450 HRK',
                'es' : 'Tasa de conversión fija: 1€ = HRK 7.53450',
                'no' : 'Fast konverteringsfrekvens: €1 = HRK 7,53450',
                'nl' : 'Vaste wisselkoers: €1 = HRK 7.53450',
                'da' : 'Fast konverteringsrate: 1 € = 7,53450 HRK',
                'sv' : 'Fast konverteringsfrekvens: 1 € = 7,53450 HRK',
                'cz' : 'Pevný směnný kurz: 1 EUR = 7,53450 HRK',
                'sl' : 'Fiksni menjalni tečaj: 1 € = 7,53450 HRK',
                'sk' : 'Pevný konverzný kurz: 1 € = 7,53450 HRK'
        };

        if (date <= x)
        {
            if (currencyId == 2) return text[language];
            return null;
        }

        if (date >= y) return null;

        if (currencyId == 1 && language == 'hr') return text[language];

        return null;
    }

    $('.showFixedExchangeRate').html(showFixedExchangeRate());

    var id = functions.getCookie('currencyIdTo') ? functions.getCookie('currencyIdTo') : 1;
    if(id && $('.currency-selected').length)
    {
        let all = JSON.parse($('.currency-selected').attr('data-currencies'));
        $('.currency-selected .currencyCode').text(all[id]);
        
       $('.currency-change').each( (i, elem) => {
           if(elem.id == id) $(elem).addClass('active');
       });
    }  

    if(id && $('.currency-selected').length)
    {
        let key = 'curr'+id;
        let rate = 1;
        let exRates = JSON.parse($('.currency-selected').attr('data-exchangeRates'));
        let ex = exRates[id];
        if (functions.getCookie(key))
        {
            rate = functions.getCookie(key);
            $('.price').each( (id, el) => {
                let price = +$(el).attr('data-priceEuro');
                let exPrice = new Intl.NumberFormat('de-DE').format(Math.round(price / rate));
                $(el).text(exPrice);
            });
        }
        else
        {
            $.post('/services/exchangeRate/', {currencyIdTo : id}).then(res => {

                let rate = +JSON.parse(res).rate;
                if (rate)
                {   
                    let expires = new Date();
                    expires.setHours(23,59,59,0);
                    document.cookie = key + '=' + rate + ';expires=' + expires.toUTCString() + '; path=/';
                    $('.price').each( (id, el) => {
                        let price = +$(el).attr('data-priceEuro');
                        let exPrice = new Intl.NumberFormat('de-DE').format(Math.round(price / rate));
                        $(el).text(exPrice);
                    });
    
                }
            });
        }

        
    }

    var id = functions.getCookie('currencyIdTo') ? functions.getCookie('currencyIdTo') : 1;
    if ($('.currency-selected').length)
    {
        let exRates = JSON.parse($('.currency-selected').attr('data-exchangeRates'));
        $('.details-currency').html(exRates[id].symbol);
    }

    ['specialModal', 'specialModalBlog'].forEach(element => {

        if(! functions.getCookie(element)) 
        {
            setTimeout(() => {
            $('#' + element).modal('show');
            if ($('#' + element).length) functions.setCookie(element, true, 1);
            }, 500);
        }
    });

    $('[id^=specialModal]').on('shown.bs.modal', e => {
    $('.modal-backdrop.show').css('opacity', '80%');
    });
    
    $('[id^=specialModal]').on('hidden.bs.modal', e => {
    $('.modal-backdrop.show').css('opacity', '50%');
    });

    $('[id^=specialModalBlog]').on('shown.bs.modal', e => {
    $('.modal-backdrop.show').css('opacity', '80%');
    });
    
    $('[id^=specialModalBlog]').on('hidden.bs.modal', e => {
    $('.modal-backdrop.show').css('opacity', '50%');
    });


    if (functions.isMobile()) 
    {
        var myCollapsible = document.getElementById('navbarSupportedContent');

        myCollapsible.addEventListener('show.bs.collapse', function (e) {
            if ($(e.target).attr('id') == 'navbarSupportedContent')
            {
                $('.main-navbar').addClass('opened');
                $('body').addClass('overflow-hidden');
            }
        })
        myCollapsible.addEventListener('hide.bs.collapse', function (e) {
            if ($(e.target).attr('id') == 'navbarSupportedContent')
            {
                $('.main-navbar').removeClass('opened');
                $('body').removeClass('overflow-hidden');
            }
        })
    }

    $('.nav-collapse').on('click', function(e) {
        let $target = $(this);
        $target.parent().toggleClass('collapse-active', ! $target.hasClass('collapsed'));
    })

    $('.result-select').on('click', function(e) {
        const $target = $(e.currentTarget);
        const $select = $target.find('.form-control');
        $select.select2('open') && $select.hasClass('select2');
    });
    
    $('.label-guide').on('click', e => {
        e.stopImmediatePropagation();
        $(e.currentTarget).find('.form-guide').trigger('focus');
    });


    //  read more component
    $('.read-more').each((i, elem) => {
        let $content = $(elem).find('.read-more-content');
        let $close = $(elem).find('.read-more-close');
        let $open = $(elem).find('.read-more-open');
        let scroll = $(elem).hasClass('scroll-to-top');


        $($open).on('click', function(e) {
            $($content).addClass('no-before expand');
            $(e.target).addClass('d-none');
            $($close).removeClass('d-none');
        })

        $($close).on('click', function(e) {
            $($content).removeClass('expand');
            $(e.target).addClass('d-none');
            $($open).removeClass('d-none');

            if (! scroll)
            {
                $('html, body').stop().animate({
                    scrollTop: $(elem).offset().top
                }, 0);
            }

            setTimeout(function() {
                $($content).removeClass('no-before');
            }, 500);

        })
    })

    

    var forms = document.querySelectorAll('.needs-validation');

    // Loop over them and prevent submission
    Array.prototype.slice.call(forms)
        .forEach(function (form) {
        form.addEventListener('submit', function (event) {
            if (!form.checkValidity()) {
                $(form).find('.required').addClass('input-empty');
                event.preventDefault();
                event.stopPropagation();
            }

            form.classList.add('was-validated')
        }, false)
    });

    $('.lang-switcher').find('.dropdown-item').each( function(index, e) {
        if (! $(e).attr('href')) $(e).remove();
    });

    function dateDiff(from, to) {
        let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
        let t = Date.UTC(to.getFullYear(), to.getMonth()+1, to.getDate());
    
        return Math.round((from - to) / (1000 * 60 * 60 * 24));
    }

    let homeSlider = [];
    $('[id^=home-slider]').each((i, elem) => {
        const $slides = $(elem).find('.keen-slider__slide');
        homeSlider[i] = new Slider('#' + $(elem).attr('id'), {
            loop: true,
            fade: true,
            arrows: true,
            slides: {
                perView: 1,
            },
            autoplay: 6000,
            defaultAnimation: {
                duration: 0
            },
            detailsChanged: (s) => {
              s.slides.forEach((element, idx) => {
                if ( s.track.details.slides[idx].portion == 0 ) {
                    element.style.opacity = 0;
                }
                if ( s.track.details.slides[idx].portion == 1 ) {
                    element.style.opacity = 1;
                    element.classList.add('animation');
                }
              })
            },
            renderMode: "custom",
        });
    });
    
});


